import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";

export interface SpinnerLease {
  release(): void;
}

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private legacyDemand = false;
  private readonly leases = new Set<symbol>();
  private visible = false;

  constructor(private spinner: NgxSpinnerService) { }

  public open(){
    this.legacyDemand = true;
    this.syncVisibility();
  }

  public close(){
    this.legacyDemand = false;
    this.syncVisibility();
  }

  public acquire(): SpinnerLease {
    const id = Symbol('spinner-lease');
    this.leases.add(id);
    this.syncVisibility();
    let released = false;
    return {
      release: () => {
        if (released) return;
        released = true;
        this.leases.delete(id);
        this.syncVisibility();
      }
    };
  }

  private syncVisibility(): void {
    const shouldShow = this.legacyDemand || this.leases.size > 0;
    if (shouldShow === this.visible) return;
    this.visible = shouldShow;
    if (shouldShow) this.spinner.show();
    else this.spinner.hide();
  }
  
}
